import FinancialCharts from "./FinancialCharts";

export default { FinancialCharts };
